import { Constants } from './constants';
import { environment } from './environment';
export default class AuthService
{

    user = null;
    get userId ()
    {
        if ( !this.userData ) return null;

        return this.userData.id;
    }
    get token ()
    {
        if ( !this.userData ) return null;

        return this.userData.token;
    }
    get userData ()
    {
        let dataOut = this.$cookies.get( environment.userData );

        if ( null == dataOut ) return null;

        let userData = JSON.parse( dataOut );
        return userData;
    }
    get authenticated ()
    {
        return ( this.userData != null );
    }

    constructor ( apiService, $q, $cookies, $state, GlobalRedirects, userService, $rootScope )
    {
        'ngInject';
        Object.assign( this, { apiService, $q, $cookies, $state, GlobalRedirects, userService, $rootScope } )
    }

    /**
     * Use this for protect pages
     * from non login users
     */
    protectRoute ()
    {
        return this.$q.resolve( this.authenticated );
    }

    login ( data )
    {
        return this.apiService
            .post( {
                url: Constants.authenticationUrl,
                name: 'login',
                data
            } )
            .then( data =>
            {
                this.storeUserData( data );
                return data;
            } )
            .catch( error =>
            {
                console.log( error );
                return this.$q.resolve( false );
            } );
    }

    getUser ( token, update )
    {
        return this.userData;
    }

    register ( data )
    {
        return this.apiService.post( {
            url: Constants.registrationsUrl,
            name: 'register',
            data
        } );
    }

    storeUserData ( data )
    {
        this.$cookies.put( environment.userData, JSON.stringify( data ) );
        this.$rootScope.userEmail = data.email
        this.userService.storeUserData( data );
    }

    logOut ()
    {
        this.$cookies.remove( environment.userData );
        this.$state.go( this.GlobalRedirects.AFTER_LOGOUT );
    }
}



// WEBPACK FOOTER //
// ./client/app/services/auth.service.js